import { getCurrentInstance } from 'vue'

/**
 * Composable for accessing i18n translation methods in Vue 3 Composition API
 *
 * Usage:
 * import { useI18n } from '@/composables/useI18n'
 *
 * setup() {
 *   const { t, currentLocale, setLocale } = useI18n()
 *
 *   return {
 *     message: t('some.translation.key')
 *   }
 * }
 */
export function useI18n() {
  const instance = getCurrentInstance()

  if (!instance) {
    throw new Error('useI18n must be called within a component setup function')
  }

  const { t, currentLocale, setLocale } =
    instance.appContext.config.globalProperties

  return {
    t,
    currentLocale,
    setLocale,
  }
}
